module.exports = __webpack_public_path__ + "static/image/company/m/image_resolutions@3x.jpg?cc015f35";